import { setHtml } from './css.js';
import { addMonths, calendarDays, todayIso, parseTime, stepTime, parseDateTime, dateRangeError, isoOf, isoWeek } from './editors.js';
import { DROP_RH, stepNumber, chosung, esc } from './grid-util.js';
export class GridDropdown {
    /** 날짜 편집 범위 (minDate/maxDate: 'YYYY-MM-DD'·'today'·함수) → ISO 또는 null */
    /** @internal */ dateBound(c, row, which) {
        const b = which === 'min' ? c.def.minDate : c.def.maxDate;
        if (b == null)
            return null;
        let v;
        try {
            v = typeof b === 'function' ? b(row, this.ds) : b;
        }
        catch {
            v = null;
        }
        if (v === 'today')
            return todayIso();
        return isoOf(v ?? null);
    }
    /** 달력 날짜를 범위 안으로 */
    /** @internal */ clampDate(c, row, d) {
        const lo = this.dateBound(c, row, 'min'), hi = this.dateBound(c, row, 'max');
        if (lo && d < lo.slice(0, 10))
            return lo.slice(0, 10);
        if (hi && d > hi.slice(0, 10))
            return hi.slice(0, 10);
        return d;
    }
    /** 날짜·시간 편집: 입력칸의 시간 부분 (없으면 00:00) */
    /** @internal */ calTime() { const m = /\s(\d{1,2}:\d{2})/.exec(this.ime.value); return m ? parseTime(m[1]) ?? '00:00' : '00:00'; }
    /** @internal */ onCalButton(b) {
        const ed = this.editing, c = this.cols[ed.ci], dt = c.def.dateKind === 'datetime';
        if (b.dataset.m) {
            this.calCur = addMonths(this.calCur || todayIso(), +b.dataset.m);
            ed.mode = 'full';
            this.renderCal();
            return;
        }
        if (b.dataset.t) { // 시·분 조절 (datetime)
            const [u, n] = [b.dataset.t[0], +b.dataset.t.slice(1)];
            const t = stepTime(this.calTime(), u === 'h' ? n * 60 : n);
            this.ime.value = (this.calCur || todayIso()) + ' ' + t;
            ed.mode = 'full';
            this.renderCal();
            return;
        }
        if (b.dataset.d) {
            if (dt) {
                this.calCur = b.dataset.d;
                this.ime.value = b.dataset.d + ' ' + this.calTime();
                ed.mode = 'full';
                this.renderCal();
                return;
            } // 날짜만 바꾸고 시간은 그대로, 확정은 Enter·지금
            this.ime.value = b.dataset.d;
            this.commitEdit();
            return;
        }
        const a = b.dataset.a;
        if (a === 'today') {
            if (dt) {
                this.calCur = todayIso();
                this.ime.value = todayIso() + ' ' + this.calTime();
                this.renderCal();
                return;
            }
            this.ime.value = todayIso();
        }
        else if (a === 'now')
            this.ime.value = parseDateTime('now').replace('T', ' ');
        else
            this.ime.value = '';
        this.commitEdit();
    }
    /** @internal */ renderCal() {
        const ed = this.editing, c = ed ? this.cols[ed.ci] : null, row = ed?.row ?? -1;
        const dt = c?.def.dateKind === 'datetime', wk = !!c?.def.weekNumbers;
        const lo = c ? this.dateBound(c, row, 'min')?.slice(0, 10) ?? null : null, hi = c ? this.dateBound(c, row, 'max')?.slice(0, 10) ?? null : null;
        const out = (d) => (lo != null && d < lo) || (hi != null && d > hi);
        const cur = this.calCur || todayIso(), today = todayIso(), ym = cur.slice(0, 7);
        const days = calendarDays(cur);
        let h = `<div class="og-calh"><button data-m="-1" aria-label="${this.t('이전 달')}">‹</button><b>${+cur.slice(0, 4)}년 ${+cur.slice(5, 7)}월</b><button data-m="1" aria-label="${this.t('다음 달')}">›</button></div><div class="og-calg${wk ? ' og-calw' : ''}">`;
        h += (wk ? `<i class="og-cwk">${this.t('주')}</i>` : '') + ['일', '월', '화', '수', '목', '금', '토'].map(w => `<i>${this.t(w)}</i>`).join('');
        h += days.map((d, i) => (wk && i % 7 === 0 ? `<i class="og-cwk">${isoWeek(days[i + 1])}</i>` : '') + `<button data-d="${d}" class="${d.slice(0, 7) !== ym ? 'og-cx' : ''}${d === today ? ' og-ctoday' : ''}${d === cur ? ' og-ccur' : ''}${i % 7 === 0 ? ' og-csun' : ''}${out(d) ? ' og-cdis' : ''}"${out(d) ? ' aria-disabled="true"' : ''}>${+d.slice(8)}</button>`).join('');
        h += '</div>';
        if (dt && c?.def.showTime !== false) {
            const [hh, mm] = this.calTime().split(':');
            h += `<div class="og-calt"><span>${this.t('시간')}</span><button data-t="h-1" aria-label="${this.t('1시간 전')}">−</button><b>${hh}</b>:<b>${mm}</b><button data-t="h1" aria-label="${this.t('1시간 후')}">+</button><button data-t="m-10" aria-label="${this.t('10분 전')}">−</button><button data-t="m10" aria-label="${this.t('10분 후')}">+</button></div>`;
        }
        const btns = c?.def.dateButtons ?? (dt ? ['today', 'now', 'clear'] : ['today', 'clear']);
        const nowIso = parseDateTime('now');
        const label = { today: this.t('오늘'), now: this.t('지금'), clear: this.t('지우기') };
        const dis = (a) => (a === 'today' && out(today)) || (a === 'now' && !!dateRangeError(nowIso, lo, hi));
        h += `<div class="og-calf">${btns.map(a => `<button data-a="${a}"${dis(a) ? ' aria-disabled="true" class="og-cdis"' : ''}>${label[a] ?? a}</button>`).join('')}</div>`;
        setHtml(this.cal, h);
        this.cal.classList.toggle('og-calwide', wk);
        this.positionIme();
    }
    /** @internal */ cellTooltip(e) {
        const el = e.target.closest('.og-c');
        if (!el || el.__ci == null)
            return;
        const c = this.cols[el.__ci], tt = c?.def.tooltip;
        const rowEl = el.closest('.og-r');
        const row = rowEl ? this.disp[rowEl.__pinVi ?? this.first + rowEl.__slot] : -1;
        const em = row != null && row >= 0 && c ? (this.getCellError(row, c.id) ?? (this.asyncPend.has(row + ':' + c.id) ? this.t('확인 중…') : null)) : null;
        if (em) {
            el.title = em;
            return;
        }
        const sc = row != null && row >= 0 && this.srvChanged.size ? this.srvChanged.get(row) : undefined;
        if (sc) {
            el.title = sc;
            return;
        }
        const nt = row != null && row >= 0 && c && this.ds.notes.size ? this.ds.getNote(row, c.id) : undefined;
        if (nt) {
            el.title = `메모: ${nt.note}${nt.userId ? ` — ${nt.userId}${nt.at ? ' ' + nt.at.replace('T', ' ').slice(0, 16) : ''}` : ''}`;
            return;
        }
        if (!tt) {
            if (el.title)
                el.title = '';
            return;
        }
        if (row == null || row < 0)
            return;
        const v = this.valueOf(c, row);
        el.title = typeof tt === 'function' ? tt(v, row, this.ds) ?? '' : this.displayText(c, v, row);
    }
    /** @internal */ comboIndex(items, fields) {
        let x = this.comboIdx.get(items);
        if (!x || x.fields.join() !== fields.join()) {
            const low = fields.map(f => items.map(i => (i[f] == null ? '' : String(i[f]).toLowerCase())));
            const cho = fields.map(f => items.map(i => (i[f] == null ? '' : chosung(String(i[f])))));
            x = { fields, low, cho };
            this.comboIdx.set(items, x);
        }
        return x;
    }
    /** @internal */ openDrop(c, q) {
        const items = this.itemsOf(c, this.editing?.row);
        const s = q.trim().toLowerCase();
        const cho = /^[ㄱ-ㅎ]+$/.test(s);
        const lc = c.def.listColumns;
        let list;
        if (lc?.length) {
            // 다중 컬럼: 목록 칸 전부에서 찾음 (코드 앞부분 → 어느 칸이든 앞부분 → 포함·초성 순)
            const fields = lc.map(x => x.field), ix = this.comboIndex(items, fields);
            if (!s)
                list = items;
            else {
                const vi = fields.indexOf('value'), a = [], b = [], d = [];
                for (let k = 0; k < items.length; k++) {
                    let rank = -1;
                    if (vi >= 0 && ix.low[vi][k].startsWith(s))
                        rank = 0;
                    else
                        for (let f = 0; f < fields.length; f++) {
                            const L = ix.low[f][k];
                            if (L.startsWith(s)) {
                                rank = 1;
                                break;
                            }
                            if (rank < 0 && (L.includes(s) || (cho && ix.cho[f][k].includes(s))))
                                rank = 2;
                        }
                    if (rank === 0)
                        a.push(items[k]);
                    else if (rank === 1)
                        b.push(items[k]);
                    else if (rank === 2)
                        d.push(items[k]);
                }
                list = a.concat(b, d);
            }
        }
        else {
            list = !s ? items : items.filter(i => i.value.toLowerCase().startsWith(s) || i.label.toLowerCase().includes(s) || (cho && chosung(i.label).includes(s)));
            // 코드 앞부분 일치를 먼저
            if (s)
                list = [...list].sort((a, b) => Number(!a.value.toLowerCase().startsWith(s)) - Number(!b.value.toLowerCase().startsWith(s)));
        }
        // 다중 컬럼·큰 목록은 가상 스크롤이라 자르지 않음 (보이는 줄만 그림)
        this.dropItems = lc?.length || list.length > 200 ? list : list.slice(0, 200);
        this.dropCol = c;
        this.dropSort = null;
        const cur = this.ds.get(this.editing.row, c.id);
        const ci = this.dropItems.findIndex(i => i.value === cur);
        // editList: 친 글자를 그대로 쓸 수 있게 처음엔 고르지 않음 (코드가 정확히 같으면 그것)
        if (c.def.listStyle === 'editList' && s)
            this.dropIdx = this.dropItems.findIndex(i => i.value.toLowerCase() === s);
        else
            this.dropIdx = s ? 0 : Math.max(0, ci);
        this.renderDrop();
    }
    /** 단추 편집기 호출 → 돌려준 값을 셀에 */
    /** @internal */ async openButtonEdit(row, c) {
        const fn = c.def.onButtonClick;
        if (!fn)
            return;
        if (this.editing && !this.commitEdit())
            return;
        const v = await fn(row, c.id, this);
        if (v !== undefined && this.ds.isVisibleRow(row) && this.canEditCol(c, row))
            this.setCellByUser([{ row, col: c.id, value: v }], this.t('편집'), 'edit');
        this.focusGrid();
    }
    /** 스핀 증감 (↑↓·휠) */
    /** @internal */ spinBy(dir, big = false) {
        const ed = this.editing;
        if (!ed || ed.kind !== 'spin')
            return;
        const d = this.cols[ed.ci].def, st = (d.spinStep ?? 1) * (big ? 10 : 1) * dir;
        this.ime.value = stepNumber(this.ime.value, st, d.min, d.max);
        this.ime.select();
    }
    /** 자동 완성 목록 (이전 값) */
    /** @internal */ openAuto(c, q) {
        const ac = c.def.autoComplete, row = this.editing?.row ?? -1, s = q.trim().toLowerCase();
        if (!s) {
            this.drop.hidden = true;
            return;
        }
        let vals;
        if (typeof ac === 'function')
            vals = ac(q, row, this.ds);
        else if (Array.isArray(ac))
            vals = ac;
        else {
            const seen = new Set(), lim = Math.min(this.ds.length, 50000);
            for (let r = 0; r < lim; r++) {
                if (r === row || !this.ds.isVisibleRow(r))
                    continue;
                const v = this.ds.get(r, c.id);
                if (v != null && v !== '')
                    seen.add(String(v));
            }
            vals = [...seen];
        }
        const pre = [], mid = [];
        for (const v of vals) {
            const l = v.toLowerCase();
            if (l === s)
                continue;
            if (l.startsWith(s))
                pre.push(v);
            else if (l.includes(s))
                mid.push(v);
        }
        const list = [...pre.sort(), ...mid.sort()].slice(0, 20);
        if (!list.length) {
            this.drop.hidden = true;
            return;
        }
        this.dropItems = list.map(v => ({ value: v, label: '' }));
        this.dropIdx = -1;
        this.renderDrop();
    }
    /** @internal */ renderDrop() {
        if (this.editing?.kind === 'checkCombo') {
            this.renderCheckCombo();
            return;
        }
        const d = this.drop;
        const c = this.editing && this.editing.kind === 'combo' ? this.dropCol : null;
        const lc = c?.def.listColumns?.length ? c.def.listColumns : null;
        if (lc || (c && this.dropItems.length > 200)) {
            this.renderDropV(c, lc);
            return;
        }
        d.classList.remove('og-dropv');
        d.style.width = '';
        d.style.maxHeight = '';
        d.removeAttribute('aria-multiselectable');
        if (!this.dropItems.length) {
            setHtml(d, '<div class="og-dn">' + this.t('일치하는 항목 없음') + '</div>');
            d.hidden = false;
            this.positionIme();
            return;
        }
        setHtml(d, this.dropItems.map((it, i) => `<div class="og-di${i === this.dropIdx ? ' og-dsel' : ''}" data-i="${i}" role="option"><b>${esc(it.value)}</b><span>${esc(it.label)}</span></div>`).join(''));
        d.hidden = false;
        this.positionIme();
        const sel = d.children[this.dropIdx];
        if (sel) {
            if (sel.offsetTop < d.scrollTop)
                d.scrollTop = sel.offsetTop;
            else if (sel.offsetTop + sel.offsetHeight > d.scrollTop + d.clientHeight)
                d.scrollTop = sel.offsetTop + sel.offsetHeight - d.clientHeight;
        }
    }
    /** @internal */ renderDropV(c, lc) {
        const d = this.drop;
        const cols = lc ?? [{ field: 'value', header: this.t('코드'), width: 90 }, { field: 'label', header: this.t('명칭'), width: 200 }];
        const rows = Math.max(3, Math.min(30, c.def.dropDownRows ?? 8)), n = this.dropItems.length;
        const widths = cols.map(x => Math.max(30, x.width ?? 100)), total = widths.reduce((a, b) => a + b, 0) + 18;
        const sig = c.id + '|' + cols.map(x => x.field + ':' + (x.width ?? '')).join(',');
        if (!d.classList.contains('og-dropv') || d.dataset.sig !== sig) {
            d.textContent = '';
            d.classList.add('og-dropv');
            d.dataset.sig = sig;
            if (lc) {
                const hd = document.createElement('div');
                hd.className = 'og-dlh';
                hd.setAttribute('role', 'presentation');
                cols.forEach((x, i) => { const sp = document.createElement('span'); sp.style.width = widths[i] + 'px'; sp.textContent = x.header ?? x.field; sp.dataset.f = x.field; sp.title = this.t('눌러서 정렬'); hd.appendChild(sp); });
                d.appendChild(hd);
            }
            const body = document.createElement('div');
            body.className = 'og-dvb';
            const inner = document.createElement('div');
            inner.className = 'og-dvi';
            body.appendChild(inner);
            d.appendChild(body);
            body.addEventListener('scroll', () => this.paintDropRows());
            this.dropBody = body;
        }
        if (!this.dropSort)
            d.querySelectorAll('.og-dlh span').forEach(sp => { if (/ [▲▼]$/.test(sp.textContent))
                sp.textContent = sp.textContent.slice(0, -2); });
        d.style.width = (c.def.dropDownWidth ?? Math.max(total, c.width)) + 'px';
        d.style.maxHeight = '';
        const body = this.dropBody;
        body.style.maxHeight = rows * DROP_RH + 'px';
        body.firstElementChild.style.height = Math.max(1, n) * DROP_RH + 'px';
        let empty = d.querySelector(':scope > .og-dn');
        if (!n) {
            if (!empty) {
                empty = document.createElement('div');
                empty.className = 'og-dn';
                d.appendChild(empty);
            }
            empty.textContent = this.t('일치하는 항목 없음');
        }
        else
            empty?.remove();
        d.hidden = false;
        d.setAttribute('aria-label', (c.def.header ?? c.id) + ' ' + this.t('목록 {n}건', { n: n.toLocaleString('ko-KR') }));
        // 고른 줄이 보이게
        const i = this.dropIdx;
        if (i >= 0) {
            const top = i * DROP_RH;
            if (top < body.scrollTop)
                body.scrollTop = top;
            else if (top + DROP_RH > body.scrollTop + body.clientHeight)
                body.scrollTop = top + DROP_RH - body.clientHeight;
        }
        this.paintDropRows(widths, cols);
        this.positionIme();
    }
    /** @internal */ sortDrop(f) {
        const c = this.dropCol;
        if (!c || !this.editing)
            return;
        const dir = this.dropSort?.f === f && this.dropSort.dir === 1 ? -1 : 1;
        this.dropSort = { f, dir };
        const cur = this.dropItems[this.dropIdx], coll = new Intl.Collator('ko', { numeric: true });
        this.dropItems = [...this.dropItems].sort((a, b) => dir * coll.compare(String(a[f] ?? ''), String(b[f] ?? '')));
        this.dropIdx = cur ? this.dropItems.indexOf(cur) : -1;
        this.drop.querySelectorAll('.og-dlh span').forEach(sp => { sp.textContent = sp.textContent.replace(/ [▲▼]$/, '') + (sp.dataset.f === f ? (dir === 1 ? ' ▲' : ' ▼') : ''); });
        this.renderDrop();
    }
    /** @internal */ paintDropRows(widths, cols) {
        if (widths && cols)
            this.dropCols = { w: widths, cols };
        const body = this.dropBody, dc = this.dropCols;
        if (!body || !dc || this.drop.hidden)
            return;
        const inner = body.firstElementChild;
        const h = body.clientHeight || DROP_RH * 8, a = Math.max(0, Math.floor(body.scrollTop / DROP_RH) - 2), b = Math.min(this.dropItems.length, a + Math.ceil(h / DROP_RH) + 5);
        while (inner.children.length < b - a) {
            const r = document.createElement('div');
            r.className = 'og-di og-dlr';
            r.setAttribute('role', 'option');
            dc.cols.forEach(() => r.appendChild(document.createElement('span')));
            inner.appendChild(r);
        }
        const kids = inner.children;
        for (let k = 0; k < kids.length; k++) {
            const r = kids[k], i = a + k;
            if (i >= b) {
                if (!r.hidden)
                    r.hidden = true;
                continue;
            }
            const it = this.dropItems[i];
            r.hidden = false;
            r.style.top = i * DROP_RH + 'px';
            r.dataset.i = String(i);
            const sel = i === this.dropIdx;
            r.className = 'og-di og-dlr' + (sel ? ' og-dsel' : '');
            r.setAttribute('aria-selected', String(sel));
            while (r.children.length < dc.cols.length)
                r.appendChild(document.createElement('span'));
            dc.cols.forEach((x, j) => { const sp = r.children[j]; sp.style.width = dc.w[j] + 'px'; const t = it[x.field] == null ? '' : String(it[x.field]); if (sp.textContent !== t)
                sp.textContent = t; sp.className = j === 0 ? 'og-dk' : ''; });
        }
    }
    /** 셀 옆 안내 (level: error 빨강 기본 · warning 노랑 · info 파랑) */
    /** @internal */ showTip(msg, level = 'error') {
        this.tip.textContent = msg;
        this.tip.classList.toggle('og-tip-warn', level === 'warning');
        this.tip.classList.toggle('og-tip-info', level === 'info');
        this.tip.hidden = false;
        this.tip.style.top = parseFloat(this.ime.style.top) - 26 + 'px';
        this.tip.style.left = this.ime.style.left;
    }
    /** @internal */ hideTip() { this.tip.hidden = true; }
}
